import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import RoleGuard from '@components/Guards/RoleGuard';

import { RoleName } from '@constants/role_name';

import AdminManagement from '@views/Admin/Management';
import { MonitoringList } from '@views/EhrSync';

const messages = defineMessages({
  title: {
    id: 'admin.integrations.title',
    defaultMessage: 'Integrations',
  },
});

function AdminIntegrationsPage() {
  const { formatMessage } = useIntl();

  // Staff-only during the internal rollout. Widen the roles when the feature
  // is finalized.
  return (
    <RoleGuard
      roles={[RoleName.Admin, RoleName.Curator, RoleName.CuratorAdmin]}
    >
      <AdminManagement.Layout title={formatMessage(messages.title)}>
        <MonitoringList />
      </AdminManagement.Layout>
    </RoleGuard>
  );
}

export default AdminIntegrationsPage;
